import { Image } from 'types/image';

export class UserLimitReachedOrExceededError extends Error {}

export interface ConsentPageRequest {
  consentChallenge: string;
}

export interface ConsentItem {
  scope: string;
  title: string;
  description: string;
  image: Image;
}

export interface ConsentPageResponse {
  title: string;
  body: string;
  logo?: Image;
  privacyPolicyText?: string;
  privacyPolicyUrl?: string;
  consentItems: ConsentItem[];
}

export interface PostConsentRequest {
  consentChallenge: string;
  accepted: boolean;
}

export interface PostConsentResponse {
  redirectUri: string;
}
